/**
 * Los avisos que alguien quitó: «Cerrar» por ahora o «No volver a mostrar».
 *
 * Son dos respuestas distintas y se guardan en dos sitios:
 *
 *   - «No volver a mostrar» va a `localStorage`, con el mismo trato que
 *     [[dashboardStars]]: no sigue a otro navegador. Aquí eso es aceptable —lo
 *     peor que pasa es ver una vez más una oferta que ya se conoce— y guardarlo
 *     en el servidor pediría una columna para una preferencia de adorno.
 *   - «Cerrar» va a `sessionStorage`: dura mientras siga abierta la pestaña. Con
 *     el estado del componente sólo, volvía al cambiar de sección y regresar,
 *     que es justo lo que se hace diez veces en una tarde.
 *
 * Por persona y no por proyecto: lo que se vende es el plan de la cuenta, y
 * quitarlo en un proyecto para encontrarlo otra vez en el siguiente sería decir
 * lo mismo tantas veces como sitios se tengan. Si el plan cambia, el aviso deja
 * de salir solo; esto no lo decide.
 */
/* `stripe-tax`: el banner que ofrece configurar impuestos. Es opcional —la
   obligación fiscal es del negocio, no de véltica, y no todos necesitan cobrar
   impuestos—, así que se puede callar para siempre. `stripe-attention`: lo que
   Stripe pide; ése sólo se cierra por sesión, porque puede frenar los cobros. */
/* `legal-attention`: vender sin términos o reembolsos publicados. Como el de
   Stripe, sólo por sesión: es una obligación del negocio, no una oferta. */
export type DismissibleNotice = 'payments-upsell' | 'stripe-tax' | 'stripe-attention' | 'legal-attention'

function storageKey(notice: DismissibleNotice): string {
  return `veltica:dismissed-notice:${notice}`
}

function sessionKey(notice: DismissibleNotice): string {
  return `veltica:closed-notice:${notice}`
}

/** Si no hay que pintarlo: quitado para siempre, o cerrado en esta sesión. */
export function isNoticeHidden(notice: DismissibleNotice): boolean {
  if (typeof window === 'undefined') return false
  try {
    return window.localStorage.getItem(storageKey(notice)) === '1'
      || window.sessionStorage.getItem(sessionKey(notice)) === '1'
  } catch {
    return false
  }
}

/** «No volver a mostrar». */
export function dismissNotice(notice: DismissibleNotice): void {
  if (typeof window === 'undefined') return
  try {
    window.localStorage.setItem(storageKey(notice), '1')
  } catch {
    // Sin almacenamiento se quita ahora y vuelve en la próxima visita.
  }
}

/** «Cerrar»: hasta que se cierre la pestaña. */
export function closeNoticeForSession(notice: DismissibleNotice): void {
  if (typeof window === 'undefined') return
  try {
    window.sessionStorage.setItem(sessionKey(notice), '1')
  } catch {
    // Sin almacenamiento se quita ahora y vuelve al cambiar de sección.
  }
}
